// @ts-ignore
import Shepherd from 'tether-shepherd';
var Tour = /** @class */ (function () {
    function Tour(steps) {
        this.steps = steps;
        this.shepherdTour = this.createShepherdTour(steps);
    }
    Tour.prototype.start = function () {
        this.shepherdTour.start();
    };
    Tour.prototype.createShepherdTour = function (steps) {
        var tour = new Shepherd.Tour({
            defaults: {
                classes: 'shepherd-theme-arrows',
                showCancelLink: true,
            },
        });
        steps.forEach(function (step, i) {
            tour.addStep(step.id, {
                title: step.title,
                text: step.text,
                attachTo: step.selector,
                buttons: getButtons(i),
            });
        });
        function getButtons(idx) {
            if (idx === 0) {
                return [
                    {
                        text: 'Exit',
                        classes: 'shepherd-button-secondary',
                        action: tour.cancel,
                    },
                    {
                        text: 'Next',
                        classes: 'shepherd-button-example-primary',
                        action: tour.next,
                    },
                ];
            }
            else {
                return [
                    {
                        text: 'Back',
                        classes: 'shepherd-button-secondary',
                        action: tour.back,
                    },
                    {
                        text: 'Finish',
                        action: tour.next,
                        classes: 'shepherd-button-example-primary',
                    },
                ];
            }
        }
        return tour;
    };
    return Tour;
}());
export default Tour;
